export function formatPhoneNumber(
  number: string | number | null | undefined,
): string {
  if (!number) return '';

  let formattedNumber = String(number).replace(/[\D]/g, '');

  if (formattedNumber.length > 10) {
    formattedNumber.slice(0, -1);
  }

  const firstThree = formattedNumber.substring(0, 3);
  const secondThree = formattedNumber.substring(3, 6);
  const thirdFour = formattedNumber.substring(6, 10);

  if (firstThree) {
    formattedNumber = `(${firstThree}`;
  }

  if (secondThree) {
    formattedNumber += `) ${secondThree}`;
  }

  if (thirdFour) {
    formattedNumber += `-${thirdFour}`;
  }
  return formattedNumber;
}

export function formatRoutingNumber(
  number: string | number | null | undefined,
): string {
  if (!number) return '';

  const formattedNumber = String(number).replace(/[\D]/g, '');

  if (formattedNumber.length > 9) {
    return formattedNumber.slice(0, -1);
  }
  return formattedNumber;
}

export function formatStringToSentence(
  value: string | null | undefined,
  formatter: string,
): string {
  if (!value) return '';
  const valueArray = value.split(formatter);
  valueArray[0] =
    valueArray[0].charAt(0).toUpperCase() + valueArray[0].slice(1);
  return valueArray.join(' ');
}

export function formatFederalTaxId(value: string): string {
  const number = String(value).replace(/[\D]/g, '');
  const chunks = [number.substring(0, 2), number.substring(2, 9)];

  return chunks[0]
    ? chunks
        .slice(1)
        .reduce((sum, next) => (next ? sum + `-${next}` : sum), chunks[0])
    : number;
}

/**
 *
 * @param fullName full name of user or customer, e.g. 'Susanna Miller'
 * @returns [string, string] first and last name of user or customer, e.g. ['Susanna', 'Miller']
 */
export const formatFullNameToFirstAndLastName = (
  fullName = '',
): [string, string] => {
  const name = fullName.split(' ');
  return [name.shift()!, name.join(' ')];
};

export const formatFirstAndLastNameToFullName = (
  firstName: string | null | undefined,
  lastName: string | null | undefined,
): string => {
  return `${firstName || ''} ${lastName || ''}`.trim();
};

export function formatToPlainNumber(n: number | string | null | undefined) {
  return n && String(n) ? String(n).replace(/[^0-9.]/g, '') : '';
}

export function formatSsn(value: string) {
  if (!value) return '';
  return value?.includes('-')
    ? value
    : `${value.slice(0, 3)}-${value.slice(3, 5)}-${value.slice(
        5,
        value.length,
      )}`;
}

export const extractWebsiteFromEmail = (email: string) => {
  const match = email?.match(/@(.*)/);
  return match && match[1];
};
